jQuery(document).ready(function() {
    'use strict';
    let cookieName = 'onBoarding';

    let getCookie = function(cookieName) {
        let name = cookieName + '=';
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
            console.log(ca);
        }
        return '';

    };

    let checkForCookie = getCookie(cookieName);

    if (checkForCookie) {
        window.location.replace('/startsida/');
    } else {
        window.location.replace('/onboarding/');
    }

    console.log(checkForCookie);

});
